/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import PT from 'prop-types';
import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  Typography,
} from '@mui/material';
import { darken, lighten } from '@mui/material/styles';
import {
  useNavigate,
  createSearchParams,
  useLocation,
  useParams,
} from 'react-router';
import qs from 'qs';
import { Box } from '@mui/system';
import TreeItemMenu from '../tree-items/tree-item-menu/index';
import AddNewAsset from '../tree-items/tree-item-menu/add-new-asset';

const ProjectParameterButton = ({ assetNodes = [] }) => {
  const { search } = useLocation();
  const { projectId } = useParams();
  const { project_parameter: projectParameters } = {
    ...qs.parse(search, { ignoreQueryPrefix: true }),
  };
  const navigate = useNavigate();
  const [moreVertVisible, setMoreVertVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isAddNewAssetOpen, setIsAddNewAssetOpen] = useState(false);
  const paramsValues = {};
  paramsValues.order = 'asc';
  paramsValues.sort_by = 'parameter_type_name';

  return (
    <>
      <Grid2
        container
        justifyContent={'space-between'}
        size={12}
        aria-label="project-parameters"
        sx={theme => ({
          backgroundColor: !projectParameters
            ? theme.palette.background.paper
            : theme.palette.mode === 'dark'
              ? `${darken(theme.palette.primary.main, 0.7)}  !important`
              : `${lighten(theme.palette.primary.main, 0.8)} !important`,
          '&:hover': {
            backgroundColor: `${theme.palette.action.selected}`,
          },
        })}
        onMouseEnter={() => setMoreVertVisible(true)}
        onMouseLeave={() => setMoreVertVisible(false)}
      >
        <Button
          variant="text"
          aria-label="project-parameters-button"
          sx={theme => ({
            width: `calc(100% - 16px)`,
            justifyContent: 'flex-start',
            textTransform: 'none',
            paddingLeft: theme.spacing(2.5),
            paddingButton: 0,
            '& .MuiTouchRipple-child': {
              left: theme.spacing(-12.5),
            },
            backgroundColor: 'transparent',
          })}
          onClick={() => {
            paramsValues.project_parameter = true;
            navigate({
              pathname: `/projects/${projectId}/parameters`,
              search: `?${createSearchParams(paramsValues)}`,
            });
          }}
        >
          <Typography variant="body2">Project</Typography>
        </Button>
        <Box
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
          }}
        >
          <TreeItemMenu
            setMenuOpen={setMenuOpen}
            moreVertVisible={moreVertVisible}
            setMoreVertVisible={setMoreVertVisible}
            menuOpen={menuOpen}
            node={{
              id: 'project',
              name: 'project',
              assetType: null,
              parent: null,
              children: [...assetNodes],
            }}
            setIsAddNewAssetOpen={setIsAddNewAssetOpen}
            projectLevelButton={true}
          />
        </Box>
      </Grid2>
      <Dialog
        fullWidth
        maxWidth="sm"
        aria-label="add-asset-dialog"
        open={isAddNewAssetOpen}
      >
        <DialogContent>
          <AddNewAsset
            setOpenNewAsset={setIsAddNewAssetOpen}
            node={{}}
            projectLevel={true}
            isNewAssetOpen={isAddNewAssetOpen}
            setExpanded={() => {}}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

ProjectParameterButton.propTypes = {
  assetNodes: PT.arrayOf(
    PT.shape({
      id: PT.string,
      name: PT.string,
      isAssetInstance: PT.bool,
      // eslint-disable-next-line react/forbid-prop-types
      children: PT.array,
    })
  ),
};

export default ProjectParameterButton;
